import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import BASE_URL from "../../Config";
import axios from "axios";

// ✅ Imported activity icons
import Breakfast from "./Activity Icon/breakfast.svg";
import CheckIn from "./Activity Icon/checkin.svg";
import Lunch from "./Activity Icon/lunch.svg";
import Dinner from "./Activity Icon/dinner.svg";
import Cocktail from "./Activity Icon/cocktail.svg";
import KitBack from "./Activity Icon/KitBack.svg";
import SecondDayLunch from "./Activity Icon/lunch.svg";
import HighTea from "./Activity Icon/Hightea.svg";

// Function to fetch data from the API
const Dashboard = () => {
  const navigate = useNavigate();
  const [batchTimeData, setBatchTimeData] = useState(null);
  const [activityData, setActivityData] = useState(null);
  const [data, setData] = useState();

  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const getSpotRegistrationData = async () => {
    try {
      const response = await fetch(`${BASE_URL}/getDelegateAndActionSummary`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({}),
      });
      const data = await response.json();
      setData(data);
      setActivityData(data?.actions);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const getActivityTypeData = async () => {
    try {
      const res = await axios.post(`${BASE_URL}/getActivityType`, { id: 1 });
      const activities = res.data?.data?.activity || [];
      setBatchTimeData(activities);
    } catch (e) {
      console.error(e);
    }
  };

  const calledOnce = useRef(false);
  useEffect(() => {
    if (calledOnce.current) return;
    calledOnce.current = true;
    getSpotRegistrationData();
    getActivityTypeData();
  }, []);

  const handleLogout = () => {
    sessionStorage.clear();
    navigate("/admin/login");
  };

  // ✅ Mapping Activity_Type_ID to icons
  const activityIcons = {
    1: Lunch,
    2: Dinner,
    3: Cocktail,
    11: Breakfast, // Breakfast → you don’t have an image, using CheckIn as fallback
    12: SecondDayLunch,
    13: HighTea,
    14: KitBack,
  };

  return (
    <div id="page" className="page">
      <div className="inner-page-wrapper">
        <section className="division wide-30">
          <div className="container">
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                padding: "10px 0",
              }}
            >
              <h2 style={{ margin: 0, fontSize: "24px", fontWeight: "bold" }}>
                Dashboard
              </h2>
              <div>
                <button
                  style={{
                    background: "#44929f",
                    padding: "6px 20px",
                    borderRadius: "40px",
                    fontSize: "16px",
                    fontWeight: 600,
                    color: "#fff",
                    border: "none",
                    cursor: "pointer",
                  }}
                  onClick={handleLogout}
                >
                  Logout
                </button>
              </div>
            </div>

            <div className="card shadow-sm border-0 rounded-3">
              <div className="card-body text-center ">
                {/* Total Delegates Card */}
                <div
                  style={{
                    cursor: "pointer",
                    background: "linear-gradient(135deg, #e0f2fe, #f0f9ff)", // soft gradient
                    borderRadius: "20px",
                    padding: "30px 20px",
                    boxShadow: "0 8px 20px rgba(0,0,0,0.08)",
                    display: "inline-block",
                    minWidth: "280px",
                    transition: "all 0.3s ease-in-out",
                    marginBottom: "30px",
                    textAlign: "center",
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.transform = "translateY(-6px)";
                    e.currentTarget.style.boxShadow =
                      "0 12px 24px rgba(0,0,0,0.15)";
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.transform = "translateY(0)";
                    e.currentTarget.style.boxShadow =
                      "0 8px 20px rgba(0,0,0,0.08)";
                  }}
                  onClick={() => navigate("/dashboard/total-delegates")}
                >
                  {/* ✅ Circle icon */}
                  <div
                    style={{
                      background: "#fff",
                      borderRadius: "50%",
                      width: "70px",
                      height: "70px",
                      margin: "0 auto 15px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      boxShadow: "0 4px 10px rgba(0,0,0,0.1)",
                    }}
                  >
                    <span style={{ fontSize: "32px" }}>👥</span>
                  </div>

                  {/* ✅ Title */}
                  <h6
                    style={{
                      fontSize: "18px",
                      fontWeight: 600,
                      marginBottom: "8px",
                      color: "#333",
                    }}
                  >
                    Total Delegates
                  </h6>

                  {/* ✅ Number */}
                  <h2
                    style={{
                      fontWeight: 700,
                      fontSize: "40px",
                      margin: 0,
                      color: "#111",
                    }}
                  >
                    {data?.totalDelegates ?? 0}
                  </h2>
                </div>

                {/* Actions Grid */}
                <div className="row mt-4 cursor-pointer">
                  {activityData &&
                    batchTimeData &&
                    [...activityData]
                      .sort((a, b) => {
                        if (a.action_type === 31) return -1; // put 31 first
                        if (b.action_type === 31) return 1; // others after
                        return 0; // keep order for the rest
                      })
                      .map((action, index) => {
                        const matchedActivity = batchTimeData.find(
                          (activity) =>
                            activity.Activity_Type_ID === action.action_type
                        );

                        const icon =
                          activityIcons[action.action_type] || CheckIn;

                        const gradients = [
                          "linear-gradient(135deg, #fff7ed, #fef3c7)",
                          "linear-gradient(135deg, #ede9fe, #f5f3ff)",
                          "linear-gradient(135deg, #fce7f3, #fff1f2)",
                          "linear-gradient(135deg, #dcfce7, #f0fdf4)",
                          "linear-gradient(135deg, #e0f2fe, #f0f9ff)",
                          "linear-gradient(135deg, #fef9c3, #fef08a)",
                          "linear-gradient(135deg, #dbeafe, #bfdbfe)",
                          "linear-gradient(135deg, #fee2e2, #fecaca)",
                          "linear-gradient(135deg, #f3e8ff, #ede9fe)",
                          "linear-gradient(135deg, #d1fae5, #a7f3d0)",
                          "linear-gradient(135deg, #fef3c7, #fde68a)",
                          "linear-gradient(135deg, #e0e7ff, #c7d2fe)",
                        ];

                        return (
                          <div
                            key={index}
                            className="col-md-3 col-6 mb-4"
                            onClick={() =>
                              navigate("/dashboard/single-activities", {
                                state: {
                                  Activity_Name:
                                    matchedActivity?.Activity_Name ||
                                    "Checked In",
                                  Activity_Type_ID:
                                    matchedActivity?.Activity_Type_ID || 31,
                                },
                              })
                            }
                          >
                            <div
                              style={{
                                background: gradients[index % gradients.length],
                                borderRadius: "20px",
                                padding: "25px 15px",
                                textAlign: "center",
                                boxShadow: "0 6px 14px rgba(0,0,0,0.08)",
                                height: "100%",
                                transition: "all 0.25s ease-in-out",
                                cursor: "pointer",
                              }}
                              onMouseEnter={(e) =>
                                (e.currentTarget.style.transform =
                                  "translateY(-6px)")
                              }
                              onMouseLeave={(e) =>
                                (e.currentTarget.style.transform =
                                  "translateY(0)")
                              }
                            >
                              <div
                                style={{
                                  background: "rgba(255,255,255,0.7)",
                                  borderRadius: "50%",
                                  width: "70px",
                                  height: "70px",
                                  margin: "0 auto 12px",
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  boxShadow: "0 3px 8px rgba(0,0,0,0.1)",
                                }}
                              >
                                <img
                                  src={icon}
                                  alt="Activity Icon"
                                  style={{
                                    width: "38px",
                                    height: "38px",
                                  }}
                                />
                              </div>

                              <h6
                                style={{
                                  fontWeight: 600,
                                  marginBottom: "6px",
                                  fontSize: "15px",
                                  color: "#333",
                                }}
                              >
                                {matchedActivity
                                  ? matchedActivity.Activity_Name
                                  : "Checked In"}
                              </h6>

                              <h2
                                style={{
                                  fontWeight: 700,
                                  fontSize: "32px",
                                  margin: 0,
                                  color: "#111",
                                }}
                              >
                                {action.total}
                              </h2>
                            </div>
                          </div>
                        );
                      })}
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
};

export default Dashboard;
